import Drawer from './drawer.vue'

Drawer.install = function (Vue) {
	Vue.component(Drawer.name, Drawer);
}

export default Drawer; 